import { NgModule } from '@angular/core';
import { IonicPageModule } from 'ionic-angular';
import { KlmrFuelAddPage } from './klmr-fuel-add';

@NgModule({
  declarations: [
    KlmrFuelAddPage,
  ],
  imports: [
    IonicPageModule.forChild(KlmrFuelAddPage),
  ],
})
export class KlmrFuelAddPageModule {}



// WEBPACK FOOTER //
// ./src/pages/klmr-fuel-add/klmr-fuel-add.module.ts